/* eslint-disable */
import HttpClient from "../../shared-module/utilities/http-client";

const { ProtectedHttpClient } = HttpClient;

const TemplateApi = {
  public: {},
  private: {
    /**
     *  To fetch all template categories
     */
    fetchCategories: () => ProtectedHttpClient.get(`/templatecategories`),
    /**
     *  To fetch all template types
     */
    fetchTypes: () => ProtectedHttpClient.get(`/templatetypes`),
    /**
     *  To fetch all template placeholders
     */
    fetchPlaceholders: () => ProtectedHttpClient.get(`/templateparameters`),
    /**
     *  To fetch all templates (for a practice user, no need to specify practice id as it will be parsed from the user token)
     */
    fetchPracticeTemplates: ({ templateCategoryId = 0, practiceId } = {}) => ProtectedHttpClient.get(`/template/list/${practiceId}/${templateCategoryId}`),
    /**
     *  To fetch all system templates
     */
    fetchSystemTemplates: ({ templateCategoryId = 0, templateTypeId = 0 } = {}) => ProtectedHttpClient.get(`/systemtemplate/list/${templateTypeId}/${templateCategoryId}`),

    getTemplateById: ({ templateId } = {}) => ProtectedHttpClient.get(`/template/get/${templateId}`)
  }
};
export default TemplateApi;
